import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PercentIcon from "@mui/icons-material/Percent";
import GppGoodIcon from "@mui/icons-material/GppGood";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import GppBadIcon from "@mui/icons-material/GppBad";
import { DetalleClientesCard } from "../Components/DetalleClientesCard";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RegistrarContactoModal from "../Modal/RegistrarContactoModal";
import MedioContactoModal from "../Modal/MedioContactoModal";

import { TextField } from "@mui/material";
import { InformacionCreditoModal } from "../Modal/InformacionCreditoModal";

export const DetalleClientesScreen = () => {
  const history = useHistory();
  const { state } = useLocation();
  const [convenios, setConvenios] = useState([]);
  const [InfoCredito, setInfoCredito] = useState([]);
  const [conveniosCard, setConveniosCard] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalContacto, setOpenModalContacto] = useState(false);
  const [openModalMedioContacto, setOpenModalMedioContacto] = useState(false);
  const [modalDescarga, setModalDescarga] = useState(false);
  const [openModalCredito, setOpenModalCredito] = useState(false);
  const [selectedFactura, setSelectedFactura] = useState(1);
  const [cardSelected, setCardSelected] = useState(1);
  const [facturasSeleccionadas, setFacturasSeleccionadas] = useState([]);
  const [contactos, setContactos] = useState([]);
  const [openModalEstadocuenta, setOpenModalEstadoCuenta] = useState(false);
  const [sumaFacturas, setSumaFacturas] = useState({
    saldo: 0,
    moratorios: 0,
    pactados: 0,
    total: 0,
  });
  const [validacionCondonacion, setValidacionCondonacion] = useState(null);

  const obtenerFechaHoy = () => {
    const hoy = new Date();
    const anio = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, "0"); // Los meses son 0-indexados
    const dia = String(hoy.getDate()).padStart(2, "0");
    return `${anio}-${mes}-${dia}`;
  };

  const [fecha_convenio, setFecha_Convenio] = useState(obtenerFechaHoy());

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const handleOpenModal = () => {
    setOpenModal(true);
    // setFolio(folio)
  };

  const handleOpenModalContacto = () => {
    setOpenModalContacto(true);
    // setFolio(folio)
  };

  const handleOpenModalCredito = (folio, documento) => {
    setSelectedFactura({ folio, documento });
    setOpenModalCredito(true);
  };

  const handleCloseModalCredito = () => {
    setOpenModalCredito(false);
    setSelectedFactura({
      folio: null,
      documento: null,
    });
  };

  const handleOpenModalMedioContacto = () => {
    if (facturasSeleccionadas.length === 0) {
      Swal.fire({
        title: "CONVENIO DE PAGO",
        text: "Debes seleccionar al menos una factura.",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }
    setOpenModalMedioContacto(true);
    // setFolio(folio)
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCloseModalContacto = () => {
    setOpenModalContacto(false);
  };

  const handleCloseModalMedioContacto = () => {
    setOpenModalMedioContacto(false);
  };

  const onImprimirEstadoCuenta = (idcliente) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `FacturasEstadoCuenta/EstadoCuentaFechaPDF?idcliente=${idcliente}&fecha=${fecha_convenio}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });

        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setOpenModalEstadoCuenta(false);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `ObtenerConveniosClienteGestionar/Convenios?idcliente=${Number(
          state.idcliente
        )}&card=1`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setConvenios(result);
        setConveniosCard(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
      });
  }, []);

  useEffect(() => {
    if (state.idcliente) {
      request
        .get(
          `ObtenerDatosContactoCliente/DatosContacto?idcliente=${state.idcliente}`
        )
        .then((result) => {
          setContactos(result);
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
        });
    }
  }, [openModalContacto]);

  useEffect(() => {
    onExecute(state.idcliente);
  }, []);

  // Estatus de la condonación de interés más reciente del cliente — determina el aviso mostrado
  // arriba del footer (pendiente de autorizar / última resuelta autorizada o rechazada).
  useEffect(() => {
    if (!state.idcliente) return;
    request
      .post(`CondonacionIntereses/ValidarCondonacionesCliente?idcliente=${state.idcliente}`, {})
      .then(setValidacionCondonacion)
      .catch(() => setValidacionCondonacion(null));
  }, [state.idcliente]);

  const onExecute = async (cliente) => {
    try {
      setLoader({ ...loader, mostrar: true });
      // Define todas las solicitudes
      const requests = [
        request.get(
          `ObtenerConveniosClienteGestionar/Convenios?idcliente=${Number(
            cliente
          )}&card=1`
        ),
        // request.get(
        //   `ObtenerConveniosClienteGestionar/ObtenerInfoCredito?cliente=${Number(
        //     cliente
        //   )}`
        // ),
      ];

      // Ejecuta todas las solicitudes en paralelo
      const [result1] = await Promise.all(requests);
      setConvenios(result1);
      setConveniosCard(result1);
      // setInfoCredito(result2);
      setLoader({ ...loader, mostrar: false });
    } catch (error) {
      setLoader({ ...loader, mostrar: false });
      Swal.fire("Error", "Ocurrió un error al cargar los datos.", "error");
    }
  };

  const onExecuteCards = (idcliente, card) => {
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `ObtenerConveniosClienteGestionar/Convenios?idcliente=${Number(
            idcliente
          )}&card=${card}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setConvenios(result);
          setFacturasSeleccionadas([]);
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
        });
    });
  };

  const handleCheckboxChange = (
    isChecked,
    idfactura,
    documento,
    fecha,
    vencimiento,
    descripcion,
    diasvencido,
    importefactura,
    importepagado,
    saldo,
    interespactado,
    interesmoratorio,
    total,
    tasa,
    serie_fiscal,
    folio_fiscal
  ) => {
    if (!isChecked) {
      // Eliminar el objeto donde seleccionada es false
      setFacturasSeleccionadas((prevFacturas) =>
        prevFacturas.filter((facturas) => facturas.idfactura !== idfactura)
      );
    } else {
      // Actualizar o agregar el objeto en el array
      const existingPermissionIndex = facturasSeleccionadas.findIndex(
        (facturas) => facturas.idfactura === idfactura
      );

      if (existingPermissionIndex !== -1) {
        setFacturasSeleccionadas((prevFacturas) => [
          ...prevFacturas.slice(0, existingPermissionIndex),
          { ...prevFacturas[existingPermissionIndex], seleccionada: true },
          ...prevFacturas.slice(existingPermissionIndex + 1),
        ]);
      } else {
        // console.log(tasa)
        if (tasa === 0 || tasa === null || tasa === undefined) {
          Swal.fire({
            title: "CONVENIO DE PAGO",
            text: "Las facturas seleccionadas deben tener una tasa definida.",
            icon: "warning",
            customClass: {
              container: "mi-superpoop",
            },
          });
        } else {
          setFacturasSeleccionadas((prevFacturas) => [
            ...prevFacturas,
            {
              idfactura,
              idcliente: state.idcliente,
              documento,
              descripcion,
              fecha: fecha,
              vencimiento: vencimiento,
              diasvencido,
              importefactura,
              importepagado,
              saldo,
              interesmoratorio,
              interespactado,
              total,
              tasa,
              serie: serie_fiscal + " " + folio_fiscal,
              seleccionada: true,
            },
          ]);
        }
      }
    }
  };

  // Checkbox del thead — selecciona/deselecciona todas las facturas listadas de una vez.
  // Se omiten las facturas sin tasa definida (misma regla que la selección individual) y las
  // que no tienen ningún interés (pactado ni moratorio) — no aportan nada a una condonación.
  const tieneAlgunInteres = (con) => (con.interes_pactado || 0) > 0 || (con.interes_moratorio || 0) > 0;

  const handleSeleccionarTodas = (isChecked) => {
    if (!isChecked) {
      setFacturasSeleccionadas([]);
      return;
    }

    const nuevasFacturas = convenios
      .filter((con) => {
        const tasa = con.tasa || con.tasa_moratoria;
        return tasa !== 0 && tasa !== null && tasa !== undefined && tieneAlgunInteres(con);
      })
      .map((con) => ({
        idfactura: con.idfactura,
        idcliente: state.idcliente,
        documento: con.documento,
        descripcion: con.descripcion,
        fecha: con.fecha,
        vencimiento: con.vencimiento,
        diasvencido: con.diasvencido,
        importefactura: con.saldo,
        importepagado: con.importepagado,
        saldo: con.saldo,
        interesmoratorio: con.interes_moratorio,
        interespactado: con.interes_pactado,
        total: con.saldo_total,
        tasa: con.tasa || con.tasa_moratoria,
        serie: con.serie_fiscal + " " + con.folio_fiscal,
        seleccionada: true,
      }));

    setFacturasSeleccionadas(nuevasFacturas);
  };

  const todasSeleccionadas =
    convenios.length > 0 &&
    convenios.every((con) => {
      const tasa = con.tasa || con.tasa_moratoria;
      if (tasa === 0 || tasa === null || tasa === undefined || !tieneAlgunInteres(con)) return true;
      return facturasSeleccionadas.some((f) => f.idfactura === con.idfactura);
    });

  useEffect(() => {
    const sumaTotal = facturasSeleccionadas.reduce(
      (total, factura) => total + factura.total,
      0
    );
    const sumaMoratorio = facturasSeleccionadas.reduce(
      (total, factura) => total + factura.interesmoratorio,
      0
    );
    const sumaPactado = facturasSeleccionadas.reduce(
      (total, factura) => total + factura.interespactado,
      0
    );
    const sumaSaldo = facturasSeleccionadas.reduce(
      (total, factura) => total + factura.saldo,
      0
    );

    setSumaFacturas({
      ...sumaFacturas,
      saldo: sumaSaldo,
      moratorios: sumaMoratorio,
      pactados: sumaPactado,
      total: sumaTotal,
    });
  }, [facturasSeleccionadas]);

  const totalConveniosEncontrados = conveniosCard.length;
  const prestamonumero = conveniosCard.filter(
    (convenio) => convenio.tipo === "PC"
  );
  const totalPrestamo = prestamonumero.length;
  const operacionnumero = conveniosCard.filter(
    (convenio) => convenio.tipo === "Operacion"
  );
  const totalOperacion = operacionnumero.length;
  const revolventenumero = conveniosCard.filter(
    (convenio) => convenio.tipo === "Revolvente"
  );
  const totalRevolvente = revolventenumero.length;

  const onEstadoCuenta = () => {
    if (state.pantalla === "Dashboard CRM") {
      onImprimirEstadoCuenta(state.idcliente)

    }
    else {
      setOpenModalEstadoCuenta(true)
    }
  }

  const onRegresar = () => {
    if (state.pantalla === "Dashboard CRM") {
      history.push("/DashClientes/Main", { idcliente: state.idcliente, cliente: state.razon_social ? state.razon_social : state.cliente, pantalla: "Dashboard CRM" });

    }
    else {
      history.goBack();
    }

  }

  // Estatus de la condonación de interés más reciente del cliente, según
  // CondonacionIntereses/ValidarCondonacionesCliente (tiene_pendiente / ultimo_estatus / ultimo_folio
  // / dias_desde_autorizacion). ultimo_estatus llega como código corto ('A'/'R'/'P'), igual que
  // ObtenerCondonacionPorFolio. Una condonación ya resuelta (autorizada/rechazada) solo se avisa
  // durante los 2 días posteriores; pasado ese plazo el indicador deja de mostrarse.
  const resueltaVigente = (validacionCondonacion?.dias_desde_autorizacion ?? Infinity) <= 2;
  const estatusCondonacion = validacionCondonacion?.tiene_pendiente
    ? "pendiente"
    : validacionCondonacion?.ultimo_estatus === "A" && resueltaVigente
      ? "aprobada"
      : validacionCondonacion?.ultimo_estatus === "R" && resueltaVigente
        ? "rechazada"
        : null;
  const folioCondonacionPendiente = validacionCondonacion?.ultimo_folio || null;

  const badgeCondonacion = {
    aprobada: { icon: <GppGoodIcon />, texto: `Condonación aprobada — Folio ${folioCondonacionPendiente}`, clase: "detalle-clientes-badge-condonacion--aprobada" },
    pendiente: { icon: <GppMaybeIcon />, texto: "Condonación pendiente de autorización", clase: "detalle-clientes-badge-condonacion--pendiente" },
    rechazada: { icon: <GppBadIcon />, texto: `Condonación rechazada — Folio ${folioCondonacionPendiente}`, clase: "detalle-clientes-badge-condonacion--rechazada" },
  }[estatusCondonacion];

  const onVerCondonacionPendiente = () => {
    if (estatusCondonacion !== "pendiente" || !folioCondonacionPendiente) return;
    history.push("/Creditoycobranza/CondonacionInteres", {
      idcliente: state.idcliente,
      razonsocial: state.razonsocial,
      folio: folioCondonacionPendiente,
    });
  };

  return (
    <PlantillaScreen
      titulo={`${state.razonsocial ? state.razonsocial : state.cliente}`}
      className={"detalle-clientes-gestionar-main-screen"}
      className_main={1}
    >
      <div className="detalle-clientes-gestionar scroll-4">
        <LoaderScreen loader={loader} />
        <div className="detalle-clientes-gestionar-footer">
          <div
            className="detalle-clientes-gestionar-footer-back"
            onClick={() => onRegresar()}>
            <ArrowBackIcon /> Regresar
          </div>
        </div>
        {badgeCondonacion && (
          <div className="detalle-clientes-gestionar-estatus">
            <span
              className={`detalle-clientes-badge-condonacion ${badgeCondonacion.clase}${estatusCondonacion === "pendiente" ? " detalle-clientes-badge-condonacion--clicable" : ""}`}
              onClick={onVerCondonacionPendiente}
            >
              {badgeCondonacion.icon} {badgeCondonacion.texto}
            </span>
          </div>
        )}
        <div className={state.pantalla === "Dashboard CRM" ? "detalle-clientes-gestionar-header-sin-card" : "detalle-clientes-gestionar-header"}>
          <div className="detalle-clientes-gestionar-header-title">
            <FormatListNumberedIcon /> Listado de Facturas Registradas
          </div>
          <div
            className="detalle-clientes-gestionar-descargar-estado"

          // onClick={() => onImprimirEstadoCuenta(state.idcliente)}
          >
            <div
              className="detalle-clientes-gestionar-descargar-estado-titulo"
              onClick={() => onEstadoCuenta()}
            >
              <CloudDownloadIcon /> Estado de Cuenta
            </div>

            {openModalEstadocuenta === true && (
              <div className="detalle-modal-estado-cuenta">
                <div className="detalle-modal-estado-cuenta-titulo">
                  <div>Seleccionar Fecha</div>
                  <TextField
                    type="date"
                    fullWidth
                    size="small"
                    value={fecha_convenio}
                    onChange={({ target }) => setFecha_Convenio(target.value)}
                  />
                </div>
                <div className="detalle-modal-estado-cuenta-buttons">
                  <div onClick={() => setOpenModalEstadoCuenta(false)}>
                    Cancelar
                  </div>
                  <div onClick={() => onImprimirEstadoCuenta(state.idcliente)}>
                    <CloudDownloadIcon />
                    Descargar
                  </div>
                </div>
              </div>
            )}
          </div>
          {state.pantalla !== "Dashboard CRM" && (
            <div
              className="detalle-clientes-gestionar-agregar-contacto"
              onClick={handleOpenModalContacto}
            >
              <PersonAddIcon /> Datos de Contacto
            </div>
          )}

          {state?.ruta2 !== undefined &&
            state?.ruta2 !== null &&
            state?.ruta2 === "0" && (
              <div
                className="detalle-clientes-gestionar-header-agregar"
                onClick={async () => {
                  if (
                    !facturasSeleccionadas ||
                    facturasSeleccionadas.length === 0
                  ) {
                    await Swal.fire({
                      icon: "warning",
                      title: "Sin facturas seleccionadas",
                      text: "Por favor selecciona al menos una factura antes de continuar.",
                    });
                    return;
                  }

                  history.push(
                    "/Creditoycobranza/ListadoConveniosCliente",
                    {
                      idcliente: state.idcliente,
                      facturasSeleccionadas: facturasSeleccionadas,
                      saldo: FormatMoney(sumaFacturas.saldo),
                      moratorios: FormatMoney(sumaFacturas.moratorios),
                      interespactado: FormatMoney(sumaFacturas.pactados),
                      total: FormatMoney(sumaFacturas.total),
                      responsable: state.responsable,
                      razonsocial: state.razonsocial,
                    }
                  );
                }}
              >
                <AddCircleOutlineIcon /> Gestión de Cobranza
              </div>
            )}

          {state?.ruta2 !== undefined &&
            state?.ruta2 !== null &&
            state?.ruta2 === "0" && (
              <div
                className="detalle-clientes-gestionar-header-condonar"
                onClick={async () => {
                  const tieneCondonacionesCliente = (validacionCondonacion?.total_condonaciones || 0) > 0;

                  if (
                    !tieneCondonacionesCliente &&
                    (!facturasSeleccionadas || facturasSeleccionadas.length === 0)
                  ) {
                    await Swal.fire({
                      icon: "warning",
                      title: "Sin facturas seleccionadas",
                      text: "Por favor selecciona al menos una factura antes de continuar.",
                    });
                    return;
                  }

                  const facturasSinIntereses = facturasSeleccionadas.filter(
                    (factura) =>
                      !factura.interespactado && !factura.interesmoratorio
                  );
                  if (facturasSinIntereses.length > 0) {
                    await Swal.fire({
                      icon: "warning",
                      title: "Facturas sin intereses",
                      text: `Las siguientes facturas no cuentan con intereses y no pueden condonarse: ${facturasSinIntereses
                        .map((factura) => factura.documento)
                        .join(", ")}`,
                    });
                    return;
                  }

                  history.push("/Creditoycobranza/CondonacionInteres", {
                    idcliente: state.idcliente,
                    facturasSeleccionadas: facturasSeleccionadas,
                    saldo: FormatMoney(sumaFacturas.saldo),
                    moratorios: FormatMoney(sumaFacturas.moratorios),
                    interespactado: FormatMoney(sumaFacturas.pactados),
                    total: FormatMoney(sumaFacturas.total),
                    responsable: state.responsable,
                    razonsocial: state.razonsocial,
                  });
                }}
              >
                <PercentIcon /> Condonación de Interés
              </div>
            )}
          <RegistrarContactoModal
            open={openModalContacto}
            onClose={handleCloseModalContacto}
            idcliente={state.idcliente}
          />
          <MedioContactoModal
            open={openModalMedioContacto}
            onClose={handleCloseModalMedioContacto}
            facturasSeleccionadas={facturasSeleccionadas}
            idcliente={state.idcliente}
            saldo={FormatMoney(sumaFacturas.saldo)}
            moratorios={FormatMoney(sumaFacturas.moratorios)}
            interespactado={FormatMoney(sumaFacturas.pactados)}
            total={FormatMoney(sumaFacturas.total)}
            responsable={state.responsable}
          />
        </div>
        <div className="detalle-clientes-gestionar-container-total">
          {state.pantalla !== "Dashboard CRM" && (
            <div className="detalle-clientes-gestionar-container-resumen">
              <DetalleClientesCard
                titulo={"TOTAL"}
                cantidad={totalConveniosEncontrados}
                className={
                  "detalle-clientes-gestionar-container-resumen-item-click"
                }
                onClick={() => {
                  onExecuteCards(state.idcliente, 1);
                  setCardSelected(1);
                }}
                porcentaje={"100%"}
                activo={cardSelected === 1 ? true : false}
              />
              <DetalleClientesCard
                titulo={"REVOLVENTE"}
                cantidad={totalRevolvente}
                className={
                  "detalle-clientes-gestionar-container-resumen-item-click"
                }
                onClick={() => {
                  onExecuteCards(state.idcliente, 2);
                  setCardSelected(2);
                }}
                porcentaje={`${FormatMoney(
                  (totalRevolvente / totalConveniosEncontrados) * 100,
                  0
                )}%`}
                activo={cardSelected === 2 ? true : false}
              />
              <DetalleClientesCard
                titulo={"OPERACIÓN"}
                cantidad={totalOperacion}
                className={
                  "detalle-clientes-gestionar-container-resumen-item-click"
                }
                onClick={() => {
                  onExecuteCards(state.idcliente, 3);
                  setCardSelected(3);
                }}
                porcentaje={`${FormatMoney(
                  (totalOperacion / totalConveniosEncontrados) * 100,
                  0
                )}%`}
                activo={cardSelected === 3 ? true : false}
              />
              <DetalleClientesCard
                titulo={"PRESTAMOS"}
                cantidad={totalPrestamo}
                className={
                  "detalle-clientes-gestionar-container-resumen-item-click"
                }
                onClick={() => {
                  onExecuteCards(state.idcliente, 4);
                  setCardSelected(4);
                }}
                porcentaje={`${FormatMoney(
                  (totalPrestamo / totalConveniosEncontrados) * 100,
                  0
                )}%`}
                activo={cardSelected === 4 ? true : false}
              />
            </div>
          )}

          <div className="detalle-clientes-gestionar-container scroll-4">
            <table>
              <thead>
                <tr>
                  {state.pantalla !== "Dashboard CRM" && (
                    <th>
                      <input
                        type="checkbox"
                        checked={todasSeleccionadas}
                        onChange={(event) => handleSeleccionarTodas(event.target.checked)}
                      />
                    </th>
                  )}
                  <th>
                    <div>Serie</div>
                  </th>
                  <th>
                    <div>No. Factura</div>
                  </th>
                  <th>
                    <div>Fecha</div>
                  </th>
                  <th>
                    <div>Vencimiento</div>
                  </th>
                  <th>
                    <div>Dias Vencido</div>
                  </th>
                  <th>
                    <div>Tasa</div>
                  </th>
                  <th>
                    <div>Saldo</div>
                  </th>
                  <th>
                    <div>Ints. Pactados</div>
                  </th>
                  <th>
                    <div>Ints. Moratorios</div>
                  </th>
                  <th>
                    <div>Total</div>
                  </th>
                  <th>
                    <div style={{ color: "transparent" }}>.</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {convenios.map((con) => (
                  <tr>
                    {state.pantalla !== "Dashboard CRM" && (
                      <td>
                        <input
                          type="checkbox"
                          checked={facturasSeleccionadas.some(
                            (factura) => factura.idfactura === con.idfactura
                          )}
                          onChange={(event) =>
                            handleCheckboxChange(
                              event.target.checked,
                              con.idfactura,
                              con.documento,
                              con.fecha,
                              con.vencimiento,
                              con.descripcion,
                              con.diasvencido,
                              con.saldo,
                              con.importepagado,
                              con.saldo,
                              con.interes_pactado,
                              con.interes_moratorio,
                              con.saldo_total,
                              con.tasa || con.tasa_moratoria,
                              con.serie_fiscal,
                              con.folio_fiscal
                            )
                          }
                        ></input>
                      </td>
                    )}
                    {/* <td className="ta-center">{con.pagare}</td> */}
                    <td className="ta-center">
                      {con.serie_fiscal + " - " + con.folio_fiscal}
                    </td>
                    <td className="ta-center">{con.documento}</td>
                    <td className="ta-center">{con.fecha}</td>
                    <td className="ta-center">{con.vencimiento}</td>
                    <td className="ta-center">
                      {con.diasvencido < 1 ? "" : con.diasvencido}
                    </td>
                    <td className="ta-right">
                      {con.tipo === "Revolvente" || con.tipo === "RS"
                        ? con.tasa_moratoria
                        : con.tasa}
                      %
                    </td>
                    <td className="ta-right">{FormatMoney(con.saldo)}</td>
                    <td className="ta-right">
                      {con.interes_pactado === 0
                        ? "-"
                        : FormatMoney(con.interes_pactado)}
                    </td>
                    <td className="ta-right">
                      {con.interes_moratorio === 0
                        ? "-"
                        : FormatMoney(con.interes_moratorio)}
                    </td>
                    <td className="ta-right">{FormatMoney(con.saldo_total)}</td>
                    <td
                      className={
                        con.folio_solicitud !== "0000000000000"
                          ? "button-visualizar"
                          : "button-sin-visualizar"
                      }
                      onClick={() => {
                        // const detalleCredito = InfoCredito?.find(
                        //   (i) => i.documento_pagare === con.documento
                        // );
                        if (con.folio_solicitud !== "0000000000000") {
                          handleOpenModalCredito(
                            con.folio_solicitud,
                            con.documento
                          );
                        }
                      }}
                    >
                      <VisibilityIcon />
                      {/* {con.folio_solicitud} */}
                    </td>
                  </tr>
                ))}
              </tbody>
              {sumaFacturas.total == 0 ? (
                <div></div>
              ) : (
                <tfoot>
                  <tr>
                    <td className="ta-right" colSpan={6}></td>
                    <td className="ta-right">Total:</td>
                    <td className="ta-right">
                      {FormatMoney(sumaFacturas.saldo)}
                    </td>
                    <td className="ta-right">
                      {FormatMoney(sumaFacturas.pactados)}
                    </td>
                    <td className="ta-right">
                      {FormatMoney(sumaFacturas.moratorios)}
                    </td>
                    <td className="ta-right">
                      {FormatMoney(sumaFacturas.total)}
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
        <InformacionCreditoModal
          open={openModalCredito}
          onClose={handleCloseModalCredito}
          folio={selectedFactura.folio}
          documento={selectedFactura.documento}
        />
      </div>
    </PlantillaScreen>
  );
};
